module.exports = __webpack_public_path__ + "img/gh-40370-3.prt.326c7831.jpg";